import Swiper, {SwiperOptions,Pagination,Navigation,Parallax,EffectFade,Autoplay} from 'swiper';
import 'swiper/css/bundle';

Swiper.use([Pagination,Navigation,Parallax,EffectFade,Autoplay]);



class MvCarouselPics {
  private carouselLeftEl:HTMLElement;
  private carouselCenterEl:HTMLElement;
  private carouselRightEl:HTMLElement;

  private swiperLeft:Swiper;
  private swiperCenter:Swiper;
  private swiperRight:Swiper;

  public currentSlide:number = 0;
  public numSlides:number;

  private autoplayDuration:number;

  constructor(_autoplayDuration:number) {
    this.carouselLeftEl = document.querySelector('#mvCarouselLeft');
    this.carouselCenterEl = document.querySelector('#mvCarouselCenter');
    this.carouselRightEl = document.querySelector('#mvCarouselRight');

    this.autoplayDuration = _autoplayDuration;

    this.init();
  }

  init() {

    this.numSlides = this.carouselCenterEl.querySelectorAll('.swiper-slide').length;

    this.swiperCenter = new Swiper(`#mvCarouselCenter .swiper`, {
      loop: true,
      slidesPerView: 1,
      initialSlide: 0,
      parallax: true,
      speed: 700,
      autoplay: {
        delay: this.autoplayDuration,
        disableOnInteraction: false,
      },
      pagination: {
        el: '.mv__carousel-nav-dots',
        clickable: true,
      },
      navigation: {
        nextEl: '.mv__carousel-nav-next',
        prevEl: '.mv__carousel-nav-prev',
      },
      on: {
        autoplayStart: () => {
          console.log('autoplayStart');
          const event = new CustomEvent('autoplayStart');
          window.dispatchEvent(event);
        },
      },
    });

    this.swiperLeft = new Swiper(`#mvCarouselLeft .swiper`, {
      loop: true,
      slidesPerView: 1,
      initialSlide: this.numSlides - 1,
      effect: 'fade',
      speed: 700,
      allowTouchMove: false,
    });
    
    this.swiperRight = new Swiper(`#mvCarouselRight .swiper`, {
      loop: true,
      slidesPerView: 1,
      initialSlide: 1,
      effect: 'fade',
      speed: 700,
      allowTouchMove: false,
    });

    

    this.swiperCenter.on('slideChange', (e) => {

      this.currentSlide = e.realIndex;

      this.swiperLeft.slideTo(this.currentSlide);
      this.swiperRight.slideTo(this.currentSlide + 2);

      //イベント
      const event = new CustomEvent('slideChange');
      window.dispatchEvent(event);
    });

    this.swiperCenter.on('transitionStart', (e) => {
      const event = new CustomEvent('transitionStart');
      window.dispatchEvent(event);
    });

    this.swiperCenter.on('transitionEnd', (e) => {
      const event = new CustomEvent('transitionEnd');
      window.dispatchEvent(event);
    });

    this.carouselLeftEl.addEventListener('click', () => {
      this.swiperCenter.slidePrev();
    });

    this.carouselRightEl.addEventListener('click', () => {
      this.swiperCenter.slideNext();
    });
  }

  next() {
    this.swiperCenter.slideNext();
  }
}

export default MvCarouselPics;

